export default __webpack_public_path__ + "static/media/praying-hands-emoji.0ba28e2f.png";